// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: Navbar.css */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}



.slick-next {
    right: 50px !important;
}
.slick-prev{
    left: 25px !important;
    z-index: 9;
}
.slick-prev:before, .slick-next:before{
    font-size: 50px !important;
}
.slick-slide img{
    height: 500px;
    object-fit: cover;
    width: 100%;
    position: relative;
}
.slick-slide{
    height: 500px !important;
}
.slick-slide::after{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #111d35;
    opacity: 0.5;
}
.bannerContentWrap{
    position: absolute;
    top: 75%;
    left: 50%;
    transform: translate(-50%, -50%) !important;
    color: #fff;
    z-index: 2;
    text-align: center;
    width: 80%;
}
.bannerContentText{
    margin-bottom: 0;
    font-size: 40px;
    font-family: "Merienda";
}
.slick-prev:hover:before, .slick-prev:focus:before, .slick-next:hover:before, .slick-next:focus:before{
    color: #cdac7d;
}
.teamSection .slick-prev:before, .teamSection .slick-next:before{
    color: #cdac7d;
}

.nav-tabs .nav-link.active {
  color: #fff;
  background-color: #007bff;
}

/* Navbar */
body {
  margin: 0;
  font-family: sans-serif;
}
/* Navbar CSS Start Here */

.navbar.customNavbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: #333;
  color: white;
  position: relative;
  z-index: 10;
  background-color: #fff;
  padding: 0 25px;
  color: #000;
}

.navbar.customNavbar .navbar-logo {
  font-size: 24px;
  font-weight: bold;
}

.navbar.customNavbar .navbar-links {
  display: flex;
  list-style: none;
  gap: 24px;
  align-items: center;
  margin: 0;
  padding: 0;
}

.navbar.customNavbar .navbar-links li {
  position: relative;
}

.navbar-links li a,
.navbar.customNavbar .dropdown-toggle {
  color: #000;
  text-decoration: none;
  font-size: 16px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 15px 0;
}
.navbar.customNavbar .freeWrap{
  background-color: #7a60ff;
  color: #fff;
  padding: 15px 15px;
}
.navbar.customNavbar .dropdown-toggle svg{
  font-size: 12px;
  margin-top: 2px;
}
.navbar.customNavbar .hamburger svg{
  color: #7a60ff;
}
.navbar-links li a.active {
  color: #7a60ff;
}

/* HOVER DROPDOWN FOR DESKTOP */
@media (min-width: 769px) {
  .dropdown:hover .dropdown-menu {
    display: block;
  }
}

.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: #444;
  list-style: none;
  margin: 0;
  padding: 8px 0;
  min-width: 180px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
  z-index: 5;
}

.dropdown-menu li {
  padding: 8px 16px;
}

.dropdown-menu li a {
  color: white;
  display: block;
  text-decoration: none;
}

.dropdown-menu li a:hover {
  color: #7a60ff;
}

/* Mobile Styles */
.hamburger {
  display: none;
  font-size: 24px;
  cursor: pointer;
}

.sidebar {
  position: fixed;
  top: 0;
  right: -100%;
  width: 260px;
  height: 100vh;
  background-color: #fff;
  color: #7a60ff;
  padding: 24px;
  transition: right 0.3s ease;
  z-index: 20;
}

.sidebar.open {
  right: 0;
}

.sidebar ul {
  list-style: none;
  padding: 0;
  margin-top: 25px;
}

.sidebar ul li {
  margin-bottom: 20px;
}

.sidebar ul li a {
  color: #7a60ff;
  font-size: 14px;
  text-decoration: none;
}

.sidebar details summary {
  font-size: 14px;
  cursor: pointer;
  color: #7a60ff;
  list-style: none;
}
.sidebar details summary svg{
  font-size: 12px;
}
.sidebar .sidebar-submenu {
  padding-left: 16px;
  margin-top: 10px !important;
    background: #dfdcef;
    border-radius: 10px;
    padding: 12px !important;
    color: #fff;
}

.sidebar .sidebar-submenu li {
  margin-bottom: 10px;
}
.sidebar .sidebar-submenu li:last-child{
  margin-bottom: 0;
}

.close-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 24px;
  cursor: pointer;
}
.sidebar ul li a.freeMobile{
    background-color: #7a60ff;
    color: #fff;
    padding: 12px 24px;
    display: block;
    margin: 0 -24px;
}

/* Overlay */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.4);
  z-index: 15;
}

/* Responsive */
@media (max-width: 768px) {
  .navbar.customNavbar .navbar-links {
    display: none;
  }

  .hamburger {
    display: block;
    padding: 10px 0;
  }
}
/* Tab CSS Start Here */

.bodyTabWrap{
  background: #f6f8f8;
  padding: 50px 0;
  overflow-y: auto;
  max-height: 100vh;
}
.tabWrap{
  background: #fff;
  max-width: 400px;
  box-shadow: 0 1px 12px #817b7b61;
  padding: 30px 30px;
  margin: auto;
  border-radius: 10px;
}
.tabWrap .nav-tabs{
  /* border: 1px solid #7a60ff;
  border-radius: 6px; */
  max-width: 300px;
  border: none;
  display: flex;
  margin: auto;
}
.tabWrap .nav-tabs .nav-link{
  background: #dfdcef;
  width: 50%;
  color: #7a60ff;
  padding: 10px 40px;
  font-weight: 500;
  text-align: center;
  border: none;
  border-radius: 0;
}
.tabWrap .nav-tabs .nav-link.active{
  background: #7a60ff;
  color: #fff;
}
.formWrap label{
  font-size: 14px;
  color: #404040;
  margin-top: 15px;
}
.formWrap .form-control{
  border: 1px solid #cbc5c5;
  background: #fdfdfd;
  border-radius: 6px;
}
.formWrap input::placeholder{
  color: #cbc5c5;
  /* font-size: 12px; */
}
.formWrap .form-control:focus{
  box-shadow: none;
  border-color: #7a60ff;
}
.forgotPassword{
  text-align: right;
  color: #8194df;
  margin-top: 5px;
}
.forgotPassword a{
  text-decoration: none;
  transition: all 0.3s ease;
}
.forgotPassword a:hover{
  text-decoration: underline;
}
.buttonWrap{
  margin-top: 30px;
}
.buttonWrap button{
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  background: #7a60ff;
  color: #fff;
  border: none;
  padding: 10px;
}
.buttonWrap button:active,
.buttonWrap button:hover{
  background-color: #6b52e0 !important;
}
.formWrap .was-validated .form-control:invalid{
  background-image: revert;
}
.passwordInput{
  position: relative;
}
.passwordInput span{
  position: absolute;
  /* top: 50%; */
  right: 10px;
  /* transform: translateY(-50%); */
  top: 5px;
  cursor: pointer;
  z-index: 9;
}
.formWrap .input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){
  border-radius: 6px !important;
}
.formWrap .was-validated .form-control:valid:focus,
.formWrap .input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){
  box-shadow: none !important;
}
.formWrap .form-control.is-invalid:focus, .was-validated .form-control:invalid:focus{
  border-color: #0000;
  box-shadow: none !important;
}
/* styles.css */
.custom-autofill:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  -webkit-text-fill-color: #000 !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
/* Remove the default caret (arrow icon) */
.dropdown-toggle::after {
  display: none !important;
}




.vertical-tab-container {
  display: flex;
  height: 100vh;
}

.tab-sidebar {
  width: 220px;
  background-color: #2c3e50;
  display: flex;
  flex-direction: column;
  /* padding-top: 10px; */
}

.vertical-tab-container .tab-button {
  padding: 15px 20px;
  background: none;
  border: none;
  color: #ecf0f1;
  text-align: left;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s ease;
  border-bottom: 1px solid #34495e;
}

.vertical-tab-container .tab-button:hover,
.vertical-tab-container .tab-button.active {
  background-color: #1abc9c;
  font-weight: bold;
}

.tab-main-content {
  flex: 1 1;
  padding: 10px;
  background: #ecf0f1;
  overflow: hidden;
}

.scrollable-content {
  background: white;
  border-radius: 5px;
  padding: 20px;
  height: calc(100vh - 80px);
  overflow-y: auto;
  border: 1px solid #ccc;
  white-space: normal;
}
.doctor-header{
  background: #535fc4;
  color: #fff;
  padding: 12px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-title{
  font-size: 20px;
  font-weight: bold;
}
.header-actions{
  display: flex;
  align-items: center;
  gap: 10px;
}
.doctor-profile{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
}
.doctor-name{
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}
.doctor-designation{
  font-size: 14px;
  color: #fff;
}
.tab-right-sidebar{
  width: 290px;
  background-color: #2c3e50;
}
.tab-main-content h2{
  margin-bottom: 0;
  display: none;
}

/* Calendar CSS Start Here */
.calendar-container {
  width: 100%;
  max-width: 500px;
  margin: auto;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.calendar-header button {
  background-color: #1abc9c;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 5px;
  cursor: pointer;
}

.calendar-header span {
  font-weight: bold;
  font-size: 18px;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
}

.calendar-cell {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ecf0f1;
  border-radius: 4px;
}

.header-cell {
  background: #bdc3c7;
  font-weight: bold;
}

.day {
  cursor: pointer;
}

.today {
  background-color: #f39c12;
  color: white;
  font-weight: bold;
}

.empty {
  background: transparent;
}
/* Horizontal tab */


.appointment-container {
  /* max-width: 600px;
  margin: 40px auto;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1); */
}

.appointment-container .tab-row {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 2px solid #ddd;
}

.appointment-container .tab-button {
  flex: 1 1;
  padding: 10px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  color: #333;
  background-color: #f0f0f0;
}
.appointment-container .tab-button:not(:first-child){
  border-left: 2px solid #ddd;
}

.appointment-container .tab-button:hover {
  background-color: #f0f0f0;
}
.appointment-container .tab-button.active:hover{
  background-color: #1abc9c;
  color: #fff;
  border-bottom: 3px solid #007bff;
}

.appointment-container .tab-button.active {
  border-bottom: 3px solid #007bff;
  font-weight: bold;
  color: #fff;
}

.appointment-container .tab-content h3 {
  margin-top: 0;
}

.appointment-container .tab-content ul {
  list-style: none;
  padding-left: 0;
}

.appointment-container .tab-content li {
  padding: 10px;
  border-bottom: 1px solid #eee;
}
.scrollable-content h3{
  margin-bottom: 15px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}

.data-table th,
.data-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.data-table th {
  background-color: #f4f4f4;
  text-align: left;
}

.calendar-cell.day.selected {
  background-color: #2980b9;
  color: white;
  font-weight: bold;
  border-radius: 4px;
}

.selected-date-display {
  margin-top: 20px;
  padding: 10px;
  background: #eef6fc;
  border: 1px solid #2980b9;
  border-radius: 6px;
  max-width: 250px;
}

.selected-date-display h4 {
  margin-bottom: 10px;
  color: #2980b9;
}

.selected-date-grid {
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px 20px;
  font-size: 14px;
}

.calendar-cell.day.selected {
  background-color: #2980b9;
  color: white;
  font-weight: bold;
  border-radius: 4px;
}

.selected-date-display {
  margin-top: 20px;
  padding: 15px;
  background: #eef6fc;
  border: 1px solid #2980b9;
  border-radius: 6px;
  max-width: 320px;
}

.selected-date-display h4 {
  margin-bottom: 10px;
  color: #2980b9;
}

.selected-date-grid {
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px 20px;
  font-size: 14px;
}

.selected-date-display button {
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #2980b9;
  border-radius: 4px;
  background: white;
  transition: background-color 0.3s ease;
}

.selected-date-display button:hover:not(:disabled) {
  background-color: #2980b9;
  color: white;
}

.selected-date-display button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.selected-date-display {
  max-width: 320px; /* or whatever width fits your layout */
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.selected-date-grid {
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px 20px;
  font-size: 14px;
}

.generated-link a {
  color: #2980b9;
  text-decoration: underline;
  word-break: break-all;  /* THIS ensures long URLs break nicely */
  display: inline-block;
  max-width: 100%;
}

.link-copy-container {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  word-break: break-all;
  margin-top: 5px;
}

.copy-button {
  padding: 4px 8px;
  font-size: 12px;
  border: 1px solid #2980b9;
  background-color: #fff;
  color: #2980b9;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.copy-button:hover {
  background-color: #2980b9;
  color: #fff;
}

.copy-success {
  color: green;
  font-size: 12px;
  margin-top: 5px;
}

.input-group {
  display: flex;
  flex-direction: column;
}

.input-group label {
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: 500;
}

.input-group select,
.input-group input[type="date"],
.input-group input[type="time"] {
  padding: 8px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  min-width: 160px;
}

.input-group button {
  padding: 8px 16px;
  font-size: 14px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.input-group button:hover {
  background-color: #0056b3;
}



button {
  padding: 8px 16px;
  background-color: #007bff;
  color: blue;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

.errorMessage{
  color: red;
}

.inline-input {
  display: flex;
  flex-direction: column;
  min-width: 160px;
}

.inline-input label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
}

.inline-input select,
.inline-input input[type="date"],
.inline-input input[type="time"] {
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.inline-input button {
  padding: 8px 16px;
  font-size: 14px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.inline-input button:hover {
  background-color: #0056b3;
}


.full-width-table th {
  background-color: #f0f0f0; /* keep the light background */
  color: #007bff; /* bootstrap-like blue color */
  font-weight: bold;
  padding: 10px;
  border: 1px solid #ccc;
}





`, "",{"version":3,"sources":["webpack://./src/assets/main.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;;;AAIA;IACI,sBAAsB;AAC1B;AACA;IACI,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2CAA2C;IAC3C,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,SAAS;EACT,uBAAuB;AACzB;AACA,0BAA0B;;AAE1B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,2BAA2B;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;AACA,uBAAuB;;AAEvB;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;uBACqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,iCAAiC;EACjC,QAAQ;EACR,eAAe;EACf,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA,eAAe;AACf;EACE,yDAAyD;EACzD,wCAAwC;EACxC,yDAAiD;EAAjD,iDAAiD;AACnD;AACA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;AACA,0CAA0C;AAC1C;EACE,wBAAwB;AAC1B;;;;;AAKA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;AACA,mBAAmB;;;AAGnB;EACE;;;;;2CAKyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB,EAAE,uCAAuC;EACzD,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,qBAAqB,GAAG,wCAAwC;EAChE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,cAAc,EAAE,8BAA8B;EAC9C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["/* File: Navbar.css */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n\n\n.slick-next {\n    right: 50px !important;\n}\n.slick-prev{\n    left: 25px !important;\n    z-index: 9;\n}\n.slick-prev:before, .slick-next:before{\n    font-size: 50px !important;\n}\n.slick-slide img{\n    height: 500px;\n    object-fit: cover;\n    width: 100%;\n    position: relative;\n}\n.slick-slide{\n    height: 500px !important;\n}\n.slick-slide::after{\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: #111d35;\n    opacity: 0.5;\n}\n.bannerContentWrap{\n    position: absolute;\n    top: 75%;\n    left: 50%;\n    transform: translate(-50%, -50%) !important;\n    color: #fff;\n    z-index: 2;\n    text-align: center;\n    width: 80%;\n}\n.bannerContentText{\n    margin-bottom: 0;\n    font-size: 40px;\n    font-family: \"Merienda\";\n}\n.slick-prev:hover:before, .slick-prev:focus:before, .slick-next:hover:before, .slick-next:focus:before{\n    color: #cdac7d;\n}\n.teamSection .slick-prev:before, .teamSection .slick-next:before{\n    color: #cdac7d;\n}\n\n.nav-tabs .nav-link.active {\n  color: #fff;\n  background-color: #007bff;\n}\n\n/* Navbar */\nbody {\n  margin: 0;\n  font-family: sans-serif;\n}\n/* Navbar CSS Start Here */\n\n.navbar.customNavbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  background-color: #333;\n  color: white;\n  position: relative;\n  z-index: 10;\n  background-color: #fff;\n  padding: 0 25px;\n  color: #000;\n}\n\n.navbar.customNavbar .navbar-logo {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.navbar.customNavbar .navbar-links {\n  display: flex;\n  list-style: none;\n  gap: 24px;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n}\n\n.navbar.customNavbar .navbar-links li {\n  position: relative;\n}\n\n.navbar-links li a,\n.navbar.customNavbar .dropdown-toggle {\n  color: #000;\n  text-decoration: none;\n  font-size: 16px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 15px 0;\n}\n.navbar.customNavbar .freeWrap{\n  background-color: #7a60ff;\n  color: #fff;\n  padding: 15px 15px;\n}\n.navbar.customNavbar .dropdown-toggle svg{\n  font-size: 12px;\n  margin-top: 2px;\n}\n.navbar.customNavbar .hamburger svg{\n  color: #7a60ff;\n}\n.navbar-links li a.active {\n  color: #7a60ff;\n}\n\n/* HOVER DROPDOWN FOR DESKTOP */\n@media (min-width: 769px) {\n  .dropdown:hover .dropdown-menu {\n    display: block;\n  }\n}\n\n.dropdown-menu {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: #444;\n  list-style: none;\n  margin: 0;\n  padding: 8px 0;\n  min-width: 180px;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.2);\n  z-index: 5;\n}\n\n.dropdown-menu li {\n  padding: 8px 16px;\n}\n\n.dropdown-menu li a {\n  color: white;\n  display: block;\n  text-decoration: none;\n}\n\n.dropdown-menu li a:hover {\n  color: #7a60ff;\n}\n\n/* Mobile Styles */\n.hamburger {\n  display: none;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.sidebar {\n  position: fixed;\n  top: 0;\n  right: -100%;\n  width: 260px;\n  height: 100vh;\n  background-color: #fff;\n  color: #7a60ff;\n  padding: 24px;\n  transition: right 0.3s ease;\n  z-index: 20;\n}\n\n.sidebar.open {\n  right: 0;\n}\n\n.sidebar ul {\n  list-style: none;\n  padding: 0;\n  margin-top: 25px;\n}\n\n.sidebar ul li {\n  margin-bottom: 20px;\n}\n\n.sidebar ul li a {\n  color: #7a60ff;\n  font-size: 14px;\n  text-decoration: none;\n}\n\n.sidebar details summary {\n  font-size: 14px;\n  cursor: pointer;\n  color: #7a60ff;\n  list-style: none;\n}\n.sidebar details summary svg{\n  font-size: 12px;\n}\n.sidebar .sidebar-submenu {\n  padding-left: 16px;\n  margin-top: 10px !important;\n    background: #dfdcef;\n    border-radius: 10px;\n    padding: 12px !important;\n    color: #fff;\n}\n\n.sidebar .sidebar-submenu li {\n  margin-bottom: 10px;\n}\n.sidebar .sidebar-submenu li:last-child{\n  margin-bottom: 0;\n}\n\n.close-icon {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  font-size: 24px;\n  cursor: pointer;\n}\n.sidebar ul li a.freeMobile{\n    background-color: #7a60ff;\n    color: #fff;\n    padding: 12px 24px;\n    display: block;\n    margin: 0 -24px;\n}\n\n/* Overlay */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.4);\n  z-index: 15;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .navbar.customNavbar .navbar-links {\n    display: none;\n  }\n\n  .hamburger {\n    display: block;\n    padding: 10px 0;\n  }\n}\n/* Tab CSS Start Here */\n\n.bodyTabWrap{\n  background: #f6f8f8;\n  padding: 50px 0;\n  overflow-y: auto;\n  max-height: 100vh;\n}\n.tabWrap{\n  background: #fff;\n  max-width: 400px;\n  box-shadow: 0 1px 12px #817b7b61;\n  padding: 30px 30px;\n  margin: auto;\n  border-radius: 10px;\n}\n.tabWrap .nav-tabs{\n  /* border: 1px solid #7a60ff;\n  border-radius: 6px; */\n  max-width: 300px;\n  border: none;\n  display: flex;\n  margin: auto;\n}\n.tabWrap .nav-tabs .nav-link{\n  background: #dfdcef;\n  width: 50%;\n  color: #7a60ff;\n  padding: 10px 40px;\n  font-weight: 500;\n  text-align: center;\n  border: none;\n  border-radius: 0;\n}\n.tabWrap .nav-tabs .nav-link.active{\n  background: #7a60ff;\n  color: #fff;\n}\n.formWrap label{\n  font-size: 14px;\n  color: #404040;\n  margin-top: 15px;\n}\n.formWrap .form-control{\n  border: 1px solid #cbc5c5;\n  background: #fdfdfd;\n  border-radius: 6px;\n}\n.formWrap input::placeholder{\n  color: #cbc5c5;\n  /* font-size: 12px; */\n}\n.formWrap .form-control:focus{\n  box-shadow: none;\n  border-color: #7a60ff;\n}\n.forgotPassword{\n  text-align: right;\n  color: #8194df;\n  margin-top: 5px;\n}\n.forgotPassword a{\n  text-decoration: none;\n  transition: all 0.3s ease;\n}\n.forgotPassword a:hover{\n  text-decoration: underline;\n}\n.buttonWrap{\n  margin-top: 30px;\n}\n.buttonWrap button{\n  width: 100%;\n  font-size: 14px;\n  font-weight: 500;\n  background: #7a60ff;\n  color: #fff;\n  border: none;\n  padding: 10px;\n}\n.buttonWrap button:active,\n.buttonWrap button:hover{\n  background-color: #6b52e0 !important;\n}\n.formWrap .was-validated .form-control:invalid{\n  background-image: revert;\n}\n.passwordInput{\n  position: relative;\n}\n.passwordInput span{\n  position: absolute;\n  /* top: 50%; */\n  right: 10px;\n  /* transform: translateY(-50%); */\n  top: 5px;\n  cursor: pointer;\n  z-index: 9;\n}\n.formWrap .input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){\n  border-radius: 6px !important;\n}\n.formWrap .was-validated .form-control:valid:focus,\n.formWrap .input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){\n  box-shadow: none !important;\n}\n.formWrap .form-control.is-invalid:focus, .was-validated .form-control:invalid:focus{\n  border-color: #0000;\n  box-shadow: none !important;\n}\n/* styles.css */\n.custom-autofill:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0px 1000px white inset !important;\n  -webkit-text-fill-color: #000 !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n/* Remove the default caret (arrow icon) */\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n\n\n\n.vertical-tab-container {\n  display: flex;\n  height: 100vh;\n}\n\n.tab-sidebar {\n  width: 220px;\n  background-color: #2c3e50;\n  display: flex;\n  flex-direction: column;\n  /* padding-top: 10px; */\n}\n\n.vertical-tab-container .tab-button {\n  padding: 15px 20px;\n  background: none;\n  border: none;\n  color: #ecf0f1;\n  text-align: left;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  border-bottom: 1px solid #34495e;\n}\n\n.vertical-tab-container .tab-button:hover,\n.vertical-tab-container .tab-button.active {\n  background-color: #1abc9c;\n  font-weight: bold;\n}\n\n.tab-main-content {\n  flex: 1;\n  padding: 10px;\n  background: #ecf0f1;\n  overflow: hidden;\n}\n\n.scrollable-content {\n  background: white;\n  border-radius: 5px;\n  padding: 20px;\n  height: calc(100vh - 80px);\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  white-space: normal;\n}\n.doctor-header{\n  background: #535fc4;\n  color: #fff;\n  padding: 12px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.header-title{\n  font-size: 20px;\n  font-weight: bold;\n}\n.header-actions{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.doctor-profile{\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #fff;\n}\n.doctor-name{\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n}\n.doctor-designation{\n  font-size: 14px;\n  color: #fff;\n}\n.tab-right-sidebar{\n  width: 290px;\n  background-color: #2c3e50;\n}\n.tab-main-content h2{\n  margin-bottom: 0;\n  display: none;\n}\n\n/* Calendar CSS Start Here */\n.calendar-container {\n  width: 100%;\n  max-width: 500px;\n  margin: auto;\n  background: #fff;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 15px;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n}\n\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.calendar-header button {\n  background-color: #1abc9c;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.calendar-header span {\n  font-weight: bold;\n  font-size: 18px;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 5px;\n}\n\n.calendar-cell {\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ecf0f1;\n  border-radius: 4px;\n}\n\n.header-cell {\n  background: #bdc3c7;\n  font-weight: bold;\n}\n\n.day {\n  cursor: pointer;\n}\n\n.today {\n  background-color: #f39c12;\n  color: white;\n  font-weight: bold;\n}\n\n.empty {\n  background: transparent;\n}\n/* Horizontal tab */\n\n\n.appointment-container {\n  /* max-width: 600px;\n  margin: 40px auto;\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1); */\n}\n\n.appointment-container .tab-row {\n  display: flex;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #ddd;\n}\n\n.appointment-container .tab-button {\n  flex: 1;\n  padding: 10px;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  color: #333;\n  background-color: #f0f0f0;\n}\n.appointment-container .tab-button:not(:first-child){\n  border-left: 2px solid #ddd;\n}\n\n.appointment-container .tab-button:hover {\n  background-color: #f0f0f0;\n}\n.appointment-container .tab-button.active:hover{\n  background-color: #1abc9c;\n  color: #fff;\n  border-bottom: 3px solid #007bff;\n}\n\n.appointment-container .tab-button.active {\n  border-bottom: 3px solid #007bff;\n  font-weight: bold;\n  color: #fff;\n}\n\n.appointment-container .tab-content h3 {\n  margin-top: 0;\n}\n\n.appointment-container .tab-content ul {\n  list-style: none;\n  padding-left: 0;\n}\n\n.appointment-container .tab-content li {\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n}\n.scrollable-content h3{\n  margin-bottom: 15px;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n}\n\n.data-table th,\n.data-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n}\n\n.data-table th {\n  background-color: #f4f4f4;\n  text-align: left;\n}\n\n.calendar-cell.day.selected {\n  background-color: #2980b9;\n  color: white;\n  font-weight: bold;\n  border-radius: 4px;\n}\n\n.selected-date-display {\n  margin-top: 20px;\n  padding: 10px;\n  background: #eef6fc;\n  border: 1px solid #2980b9;\n  border-radius: 6px;\n  max-width: 250px;\n}\n\n.selected-date-display h4 {\n  margin-bottom: 10px;\n  color: #2980b9;\n}\n\n.selected-date-grid {\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 8px 20px;\n  font-size: 14px;\n}\n\n.calendar-cell.day.selected {\n  background-color: #2980b9;\n  color: white;\n  font-weight: bold;\n  border-radius: 4px;\n}\n\n.selected-date-display {\n  margin-top: 20px;\n  padding: 15px;\n  background: #eef6fc;\n  border: 1px solid #2980b9;\n  border-radius: 6px;\n  max-width: 320px;\n}\n\n.selected-date-display h4 {\n  margin-bottom: 10px;\n  color: #2980b9;\n}\n\n.selected-date-grid {\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 8px 20px;\n  font-size: 14px;\n}\n\n.selected-date-display button {\n  padding: 6px 12px;\n  font-size: 14px;\n  cursor: pointer;\n  border: 1px solid #2980b9;\n  border-radius: 4px;\n  background: white;\n  transition: background-color 0.3s ease;\n}\n\n.selected-date-display button:hover:not(:disabled) {\n  background-color: #2980b9;\n  color: white;\n}\n\n.selected-date-display button:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.selected-date-display {\n  max-width: 320px; /* or whatever width fits your layout */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.selected-date-grid {\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 8px 20px;\n  font-size: 14px;\n}\n\n.generated-link a {\n  color: #2980b9;\n  text-decoration: underline;\n  word-break: break-all;  /* THIS ensures long URLs break nicely */\n  display: inline-block;\n  max-width: 100%;\n}\n\n.link-copy-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  word-break: break-all;\n  margin-top: 5px;\n}\n\n.copy-button {\n  padding: 4px 8px;\n  font-size: 12px;\n  border: 1px solid #2980b9;\n  background-color: #fff;\n  color: #2980b9;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.copy-button:hover {\n  background-color: #2980b9;\n  color: #fff;\n}\n\n.copy-success {\n  color: green;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.input-group label {\n  font-size: 14px;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.input-group select,\n.input-group input[type=\"date\"],\n.input-group input[type=\"time\"] {\n  padding: 8px;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  min-width: 160px;\n}\n\n.input-group button {\n  padding: 8px 16px;\n  font-size: 14px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.input-group button:hover {\n  background-color: #0056b3;\n}\n\n\n\nbutton {\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: blue;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\n.errorMessage{\n  color: red;\n}\n\n.inline-input {\n  display: flex;\n  flex-direction: column;\n  min-width: 160px;\n}\n\n.inline-input label {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.inline-input select,\n.inline-input input[type=\"date\"],\n.inline-input input[type=\"time\"] {\n  padding: 8px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.inline-input button {\n  padding: 8px 16px;\n  font-size: 14px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.inline-input button:hover {\n  background-color: #0056b3;\n}\n\n\n.full-width-table th {\n  background-color: #f0f0f0; /* keep the light background */\n  color: #007bff; /* bootstrap-like blue color */\n  font-weight: bold;\n  padding: 10px;\n  border: 1px solid #ccc;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
